/**
 * Created by liorsion on 4/7/16.
 */
'use strict';

angular
	.module('tasksProgressServices', [])
	.factory('TasksProgress', function (TasksData, Task, TimeManagerService, $translate) {
		var TASK_PROGRESS_STATUS = {
			not_done_yet: 0,
			late: 1,
			done: 2,
			missed: 3
		};

		var markedPreviousMissed = function (progressArray) {
			var currentPos = progressArray.length;
			if (currentPos > 0) {
				if (progressArray[currentPos - 1] !== TASK_PROGRESS_STATUS.done) {
					progressArray[currentPos - 1] = TASK_PROGRESS_STATUS.missed;
					return true;
				}
			}

			return false;
		};

		var lastWayPointETA = function (task) {
			if (task.way_points && task.way_points.length && task.way_points[task.way_points.length - 1].eta) {
				return task.way_points[task.way_points.length - 1].eta;
			}
			return null;
		};

		var getProgress = function (closedTasks, openTasks) {
			var progressTaskArray = _.sortBy(closedTasks.concat(openTasks), 'priority'),
				progressArray = [],
				previousTask,
				totalTasksCount = progressTaskArray.length,
				lateTasksCount = 0,
				skippedTasksCount = 0,
				doneTasksCount = 0,
				timeRouteStarted = null;

			if (Task.isStarted(progressTaskArray[0])) {
				timeRouteStarted = progressTaskArray[0].started_time;
			}

			_.each(progressTaskArray, function (currentTask) {
				if (Task.isDone(currentTask)) {
					if (markedPreviousMissed(progressArray)) {
						skippedTasksCount++;
					}
					doneTasksCount++;
					progressArray.push(TASK_PROGRESS_STATUS.done);
				} else if (Task.isLate(currentTask)) {
					if (Task.isStarted(currentTask) && markedPreviousMissed(progressArray)) {
						skippedTasksCount++;
					}
					lateTasksCount++;
					progressArray.push(TASK_PROGRESS_STATUS.late);
				} else {
					progressArray.push(TASK_PROGRESS_STATUS.not_done_yet);
				}

				previousTask = currentTask;
			});

			var label = doneTasksCount + '/' + totalTasksCount + ' ' + $translate.instant('GLOBAL.COMPLETED');

			if (lateTasksCount) {
				label += ', ' + lateTasksCount + ' ' + $translate.instant('DISPATCH_LIST.LATE');
			}

			if (skippedTasksCount) {
				label += ', ' + skippedTasksCount + ' ' + $translate.instant('DISPATCH_LIST.MISSED');
			}

			if (timeRouteStarted) {
				label +=
					', ' +
					$translate.instant('DISPATCH_LIST.TIME_ROUTE_STARTED') +
					': ' +
					TimeManagerService.format(timeRouteStarted, 'h:mm a');
			}

			var tasksEta = _.filter(_.map(progressTaskArray, lastWayPointETA));

			if (!_.isEmpty(tasksEta)) {
				var lastTaskEta = _.chain(tasksEta)
					.map(function (taskEta) {
						return new Date(taskEta);
					})
					.max()
					.valueOf();

				label +=
					', ' +
					$translate.instant('DISPATCH_LIST.LAST_ETA') +
					': ' +
					TimeManagerService.format(lastTaskEta, 'h:mm a');
			}

			return {
				progressArray: progressArray,
				label: label
			};
		};

		return {
			TASK_PROGRESS_STATUS: TASK_PROGRESS_STATUS,
			_getProgress: getProgress,
			getProgressForTeam: function (teamId, openTasks) {
				var closedTasks = TasksData.getClosed();

				if (!closedTasks) {
					return [];
				}

				closedTasks = _.filter(closedTasks, function (item) {
					return (teamId == 0 && _.isEmpty(item.team_ids)) || _.includes(item.team_ids, teamId);
				});

				return getProgress(closedTasks, openTasks);
			},
			getProgressForUsers: function (userIds, openTasks) {
				var closedTasks = TasksData.getClosed();

				if (!closedTasks) {
					return [];
				}

				// if there is no users ids, just return all of them
				if (!_.isEmpty(userIds)) {
					closedTasks = _.filter(closedTasks, function (item) {
						// handle unassigned
						if (userIds === [0] && !item.user_id) {
							return true;
						}
						return _.find(userIds, function (id) {
							return id === item.user_id;
						});
					});
				}

				return getProgress(closedTasks, openTasks);
			}
		};
	});
